import React from "react";
import Dropdown from "components/dropdown";
import { Link } from "react-router-dom";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../../utils/cookie";

import avatar from "assets/img/userIcon.png";
import { useDispatch } from "react-redux";
import { logoutAction } from "../../redux/action/index";
import { BiArrowBack } from "react-icons/bi";
import Logo2 from "../../assets/img/client_logo.png";
const Navbar = (props) => {
  const { onOpenSidenav, brandText, subBrandText } = props;
  const [darkmode, setDarkmode] = React.useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  function handleLogout() {
    try {
      dispatch(logoutAction()).then((response) => {
        if (response !== undefined) {
          localStorage.clear();
          navigate("/auth/sign-in");
        }
      });
    } catch (error) {
      console.log("Login err:", error);
    }
  }

  return (
    <nav className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="ml-[6px]">
        <div className="flex h-6 w-[250px] items-center gap-2 pt-1">
          <span
            className=" cursor-pointer text-sm font-normal text-navy-700 hover:font-bold hover:text-brand-600  dark:text-white dark:hover:text-white"
            onClick={() => {
              navigate(-1);
            }}
          >
            <BiArrowBack />
            {/* <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
              {" "}
              /{" "}
            </span> */}
          </span>
          <p
            className="text-sm font-normal capitalize text-navy-700  dark:text-white dark:hover:text-white"
            // onClick={()=>navigate()}
          >
            {brandText}
          </p>
          {subBrandText ? (
            <>
              {" "}
              <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
                {" "}
                /{" "}
              </span>
              <p
                className="text-sm font-normal capitalize text-navy-700  dark:text-white dark:hover:text-white"
                // onClick={()=>navigate()}
              >
                {subBrandText}
              </p>
            </>
          ) : null}
        </div>
        <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
          <Link
            to="#"
            className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {subBrandText ? subBrandText : brandText}
          </Link>
        </p>
      </div>

      <div className="relative mt-[3px] flex h-[61px] w-[200px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 md:w-[220px] md:flex-grow-0 md:gap-1 xl:w-[250px] xl:gap-2 dark:!bg-navy-800 dark:shadow-none">
        {" "}
        {/* {/* <div className="flex h-full items-center rounded-full bg-lightPrimary text-navy-700 xl:w-[225px] dark:bg-navy-900 dark:text-white"> */}
        {/* <p className="pl-3 pr-2 text-xl">
            <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
          </p>
          <input
            type="text"
            placeholder="Search..."
            className="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 sm:w-fit dark:bg-navy-900 dark:text-white dark:placeholder:!text-white"
          />
        </div>  */}
        {/* <span
          className="flex cursor-pointer text-xl text-gray-600 xl:hidden dark:text-white"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span> */}
        {/* start Notification */}
        <div>
          <img src={Logo2} alt="logo" width={35} />
        </div>
        <div
          className="cursor-pointer text-gray-600"
          onClick={() => {
            if (darkmode) {
              document.body.classList.remove("dark");
              setDarkmode(false);
            } else {
              document.body.classList.add("dark");
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
          )}
        </div>
        <div className="">
          <div className="px-1 text-sm font-semibold text-brand-600 dark:text-white">
            {getCookie("user_name")}{" "}
          </div>
          <div className="rounded-lg bg-lightPrimary px-1 text-xs text-brand-800 dark:bg-blueSecondary dark:text-white">
            {getCookie("role")}
          </div>
        </div>
        {/* Profile & Dropdown */}
        <Dropdown
          button={
            <img className="h-10 w-10 rounded-full" src={avatar} alt="User" />
          }
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="p-4">
                <div className="flex items-center gap-2">
                  <p className="text-xs font-bold capitalize text-navy-700 dark:text-white">
                    👋 Hey, Do you want to Logout ?
                  </p>
                </div>
              </div>
              <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />

              <div className="flex flex-col p-2 px-4">
                {/* <a
                  href=" "
                  className="text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Profile Settings
                </a> */}
                {/* <a
                  href=" "
                  className="mt-3 text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Newsletter Settings
                </a> */}
                <div
                  // href=" "
                  onClick={() => {
                    handleLogout();
                  }}
                  className="mt-1 cursor-pointer text-sm font-medium text-red-500 hover:text-red-500"
                >
                  Log Out
                </div>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
